import React from 'react'
import Modal from '../layouts/Modal';

export default function UpdateNotice() {
  return (
    <Modal open={true} persistent={true}>
      <section className="cardTitle">
        Update Notice
      </section>
      <section className="cardSection">
        <p className="copy"> The app has been updated, please refresh the browser to see the update. </p>
      </section>
      <section className="cardSection _footer">
        <button className="ds-btn _right -secondary --micro" onClick={() => {window.location.reload(true)}}>
          Refresh Page
        </button>
      </section>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/UpdateNotice.js